const terms = {
  'terms.page.backToTop': 'ページの先頭へ戻る',
  'terms.page.lastUpdated': '最終更新: 2026年6月13日',
  'terms.page.homeLink': 'ホーム',
  'terms.page.currentPage': '利用規約',

  'terms.hero.homeLink': 'ホーム',
  'terms.hero.currentPage': '利用規約',
  'terms.hero.title': '利用規約',
  'terms.hero.titleEn': 'TERMS OF SERVICE',
  'terms.hero.lead': '本規約は、一般社団法人全日本執事協会（以下「当協会」）が運営する日本執事アカデミーのウェブサイトおよび関連サービスの利用条件を定めるものです。',
  'terms.hero.imgAlt': '契約書にサインするための万年筆と書類を整えた静物',

  'terms.jsonld.breadcrumb1': 'ホーム',
  'terms.jsonld.breadcrumb2': '利用規約',
  'terms.jsonld.orgName': '日本執事アカデミー',
  'terms.jsonld.parentOrg': '一般社団法人全日本執事協会',

  'terms.toc.title': '目次',
  'terms.toc.subtitleEn': 'CONTENTS',
  'terms.article.prefix': '第',
  'terms.article.suffix': '条',

  'terms.related.title': '関連ページ',
  'terms.related.0.title': 'プライバシーポリシー',
  'terms.related.0.desc': '個人情報の取扱い方針',
  'terms.related.1.title': '特定商取引法に基づく表記',
  'terms.related.1.desc': '法定情報の開示',
  'terms.related.2.title': 'お問い合わせ',
  'terms.related.2.desc': 'ご質問・ご相談はこちら',
  'terms.related.viewMore': '見る',

  // TermsContent UI chrome
  'terms.toc.heading': '目次',
  'terms.content.preamble': '本利用規約（以下「本規約」といいます）は、一般社団法人全日本執事協会（以下「当協会」といいます）が運営する「日本執事アカデミー」のウェブサイト（以下「本サイト」といいます）および本サイトを通じて提供される関連サービス（以下「本サービス」といいます）の利用条件を定めるものです。本サイトをご利用になるすべての方は、本規約に同意のうえご利用ください。',
  'terms.content.enactDate': '制定日',
  'terms.content.enactDateValue': '準備中',
  'terms.content.lastRevised': '最終改定日',
  'terms.content.lastRevisedValue': '2026年6月13日',
  'terms.content.amendNotice': '本規約は予告なく改定する場合があります。重要な変更がある場合は、資料請求者および受講生の皆様へ個別にご案内いたします。',
  'terms.content.courseRefNote': '講座のお申込み、受講、キャンセル、返金等の条件については、本規約ではなく、別途定める募集要項および受講契約によります。詳細は',
  'terms.content.courseRefLink': '応募資格・申込の流れ',
  'terms.content.courseRefNoteEnd': 'のページをご参照ください。',

  // Article titles
  'terms.a.01.title': '適用範囲',
  'terms.a.02.title': '定義',
  'terms.a.03.title': '本サイトの利用',
  'terms.a.04.title': '知的財産権',
  'terms.a.05.title': '禁止事項',
  'terms.a.06.title': '受講契約との関係',
  'terms.a.07.title': '免責事項',
  'terms.a.08.title': 'サービスの変更・中断',
  'terms.a.09.title': '準拠法および裁判管轄',
  'terms.a.10.title': '規約の変更',

  'terms.a.01.p.0': '本規約は、一般社団法人全日本執事協会（以下「当協会」といいます）が運営する「日本執事アカデミー」のウェブサイト（以下「本サイト」といいます）および本サイトを通じて提供される関連サービス（以下「本サービス」といいます）の利用に関し、当協会と利用者（以下「利用者」といいます）との間に適用されます。',
  'terms.a.01.p.1': '利用者は、本サイトを利用することにより、本規約の内容に同意したものとみなされます。本規約に同意いただけない場合は、本サイトのご利用をお控えください。',

  'terms.a.02.p.0': '本規約において使用する用語の定義は、以下のとおりとします。',
  'terms.a.02.p.1': '「本サイト」：当協会が運営する日本執事アカデミーのウェブサイト（https://butler-academy.jp）をいいます。',
  'terms.a.02.p.2': '「本サービス」：本サイトを通じて提供される情報提供、資料請求、個別相談の受付、各種お申込み受付、お問い合わせ対応その他のサービスをいいます。',
  'terms.a.02.p.3': '「受講生」：当協会が提供する講座を受講する方をいいます。',
  'terms.a.02.p.4': '「利用者」：本サイトを閲覧または利用するすべての方をいいます。',

  'terms.a.03.p.0': '利用者は、本サイトを自己の責任において利用するものとします。',
  'terms.a.03.p.1': '当協会は、本サイトの利用に必要な機器・ソフトウェア・通信環境等について、一切の関与を行いません。',
  'terms.a.03.p.2': '当協会は、利用者に事前の通知なく、本サイトの内容の変更または運営の中断・中止を行うことができるものとします。',
  'terms.a.03.p.3': '本サイトの利用に関連して、利用者間または利用者と第三者との間に生じた紛争については、利用者が自己の責任と費用において解決するものとし、当協会は一切の責任を負いません。',

  'terms.a.04.p.0': '本サイトに掲載される文章、画像、動画、ロゴ、教材、デザイン、プログラム、その他一切のコンテンツ（以下「本コンテンツ」といいます）に関する著作権、商標権その他の知的財産権は、当協会または正当な権利を有する第三者に帰属します。',
  'terms.a.04.p.1': '利用者は、本コンテンツを、当協会の事前の書面による承諾なく、複製、転載、改変、翻案、公衆送信、頒布、貸与、翻訳、販売その他方法の如何を問わず利用することを禁じます。',
  'terms.a.04.p.2': '本条の規定に違反して第三者との間に紛争が生じた場合、利用者は自己の責任と費用において解決するものとし、当協会に損害を与えた場合はその損害を賠償するものとします。',

  'terms.a.05.p.0': '利用者は、本サイトの利用にあたり、以下の行為を行ってはならないものとします。',
  'terms.a.05.p.1': '（1）法令または公序良俗に反する行為',
  'terms.a.05.p.2': '（2）当協会または第三者の権利（知的財産権、名誉、プライバシー等）を侵害する行為',
  'terms.a.05.p.3': '（3）他の利用者、第三者または当協会になりすます行為',
  'terms.a.05.p.4': '（4）本サイトの運営を妨害する行為（大量アクセス、不正プログラムの送信等）',
  'terms.a.05.p.5': '（5）当協会の信用を毀損する行為',
  'terms.a.05.p.6': '（6）営利を目的とした情報の収集・利用',
  'terms.a.05.p.7': '（7）その他、当協会が不適切と判断する行為',
  'terms.a.05.p.8': '当協会は、利用者が本条に違反した場合、当該利用者に対し本サイトの利用停止その他の措置を講じることができるものとします。',

  'terms.a.06.p.0': '本規約は、本サイトおよび本サービスの利用条件を定めるものであり、講座の受講契約そのものを定めるものではありません。',
  'terms.a.06.p.1': '講座のお申込み、受講、キャンセル、返金等の条件については、別途定める募集要項および受講契約によります。詳細は応募資格・申込の流れのページ（/application）をご参照ください。',
  'terms.a.06.p.2': '本規約の定めと受講契約の定めとの間に齟齬がある場合は、受講契約の定めが優先して適用されるものとします。',

  'terms.a.07.p.0': '当協会は、本サイトに掲載する情報の正確性、最新性、有用性について細心の注意を払いますが、その完全性を保証するものではありません。',
  'terms.a.07.p.1': '本サイトの利用により生じたいかなる損害（間接損害、特別損害、逸失利益を含みます）についても、当協会の故意または重過失による場合を除き、当協会は責任を負いません。',
  'terms.a.07.p.2': '本サイトからリンクされた第三者のウェブサイトの内容について、当協会は一切の責任を負いません。',
  'terms.a.07.p.3': '当協会は、天災、回線障害、機器故障、保守作業その他やむを得ない事由により、本サービスの提供を一時的に中断できるものとし、これにより利用者に損害が生じた場合も、当協会の故意または重過失による場合を除き責任を負いません。',

  'terms.a.08.p.0': '当協会は、利用者に事前の通知なく、本サービスの内容を変更、追加、または廃止することができるものとします。',
  'terms.a.08.p.1': '当協会は、以下のいずれかに該当する場合、本サービスの全部または一部を一時的に中断することがあります。',
  'terms.a.08.p.2': '（1）本サイトの保守・点検を行う場合',
  'terms.a.08.p.3': '（2）天災、停電、通信回線の障害その他不測の事態により本サービスの提供が困難な場合',
  'terms.a.08.p.4': '（3）その他、当協会が運用上または技術上一時的な中断が必要と判断した場合',
  'terms.a.08.p.5': '当協会は、前項に基づく変更・中断により利用者に損害が生じた場合であっても、当協会の故意または重過失による場合を除き責任を負いません。',

  'terms.a.09.p.0': '本規約の解釈および適用は、日本国法を準拠法とします。',
  'terms.a.09.p.1': '本サービスに関連して当協会と利用者との間に紛争が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。',

  'terms.a.10.p.0': '当協会は、以下のいずれかに該当する場合、本規約を変更することができるものとします。',
  'terms.a.10.p.1': '（1）本規約の変更が利用者の一般の利益に適合するとき',
  'terms.a.10.p.2': '（2）本規約の変更が、契約をした目的に反せず、かつ変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき',
  'terms.a.10.p.3': '当協会は、本規約を変更する場合、変更後の規約の内容および効力発生日を本サイト上に掲載することにより周知します。重要な変更については、資料請求者および受講生の皆様へメール等で個別にご案内する場合があります。',
  'terms.a.10.p.4': '変更後の規約は、効力発生日以降、本サイトの継続利用をもって、利用者が変更後の規約に同意したものとみなします。',
};

export default terms;
